import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import './ComingSoon.css';

const ComingSoon = () => {
  const navigate = useNavigate();

  return (
    <div className="coming-soon-page">
      {/* Floating question marks */}
      <div className="floating-elements">
        {[...Array(12)].map((_, i) => (
          <motion.span
            key={i}
            className="floating-item"
            initial={{ y: 0, opacity: 0.3 }}
            animate={{
              y: [-20, 20, -20],
              opacity: [0.3, 0.7, 0.3],
              rotate: [0, 10, -10, 0]
            }}
            transition={{
              duration: 3 + Math.random() * 2,
              repeat: Infinity,
              delay: Math.random() * 2
            }}
            style={{
              left: `${5 + Math.random() * 90}%`,
              top: `${5 + Math.random() * 90}%`,
              fontSize: `${1.5 + Math.random() * 2}rem`
            }}
          >
            {['?', '!', '...', '??', '?!'][Math.floor(Math.random() * 5)]}
          </motion.span>
        ))}
      </div>

      {/* Main content */}
      <motion.div
        className="coming-soon-content"
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.8, type: "spring" }}
      >
        {/* Construction cone */}
        <motion.div
          className="construction-cone"
          animate={{ rotate: [-5, 5, -5] }}
          transition={{ duration: 2, repeat: Infinity }}
        >
          <div className="cone-top"></div>
          <div className="cone-stripe stripe-1"></div>
          <div className="cone-stripe stripe-2"></div>
          <div className="cone-stripe stripe-3"></div>
          <div className="cone-base"></div>
        </motion.div>

        <motion.h1
          className="coming-soon-title"
          animate={{ scale: [1, 1.02, 1] }}
          transition={{ duration: 2, repeat: Infinity }}
        >
          Woah there!
        </motion.h1>

        <motion.p
          className="coming-soon-subtitle"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
        >
          You found the secret unfinished room!
        </motion.p>

        <motion.div
          className="funny-message"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.6 }}
        >
          <p>Henry is still building this part...</p>
          <p className="small-text">(he's trying his best, okay?)</p>
        </motion.div>

        <motion.div
          className="construction-signs"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.9 }}
        >
          <span className="sign">UNDER CONSTRUCTION</span>
          <span className="sign-small">probably forever at this rate</span>
        </motion.div>

        <motion.button
          className="go-back-button"
          onClick={() => navigate('/home')}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.2 }}
          whileHover={{ scale: 1.1, rotate: [0, -2, 2, 0] }}
          whileTap={{ scale: 0.95 }}
        >
          Escape while you can!
        </motion.button>

        <motion.p
          className="footer-joke"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.5 }}
        >
          i definitely wouldn't stick around waiting
        </motion.p>
      </motion.div>
    </div>
  );
};

export default ComingSoon;
